/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react';
import LegalIcon from 'assets/images/menu/legal.svg';
import RobotDashboardIcon from 'assets/images/menu/robot-dashboard.svg';
import MoreIcon from 'assets/images/menu/more.svg';
import MarketIcon from 'assets/images/menu/market-analysis.svg';
import TrainingIcon from 'assets/images/menu/training.svg';
import ExternalRoutes from 'services/external_routes';
import { canAccessPriceIntelligence } from 'services/alfa_tools';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store';
import {
  MenusBehaviourState,
  MenusBehaviourTypes,
} from 'store/modules/menus_behaviour_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import createTrack from 'services/actions/tracker_actions';

interface SideBarMultipleItemProps {
  feature: string;
  representant: boolean;
  classTour?: string;
}

const featureIcon = (feature: string) => {
  if (feature === 'Assessoria e Consultoria') return LegalIcon;
  if (feature === 'Análise Estratégica') return MarketIcon;
  if (feature === 'Treinamento e Capacitação') return TrainingIcon;
  if (feature === 'Dashboard Robô de Lances') return RobotDashboardIcon;
  return MoreIcon;
};

const featureIdName = (feature: string) => {
  if (feature === 'Assessoria e Consultoria') return 'juridico';
  if (feature === 'Análise Estratégica') return 'analise-estrategica';
  if (feature === 'Treinamento e Capacitação') return 'treinamento';
  if (feature === 'Dashboard Robô de Lances') return 'dashboard';

  return 'mais';
};

const featureItems = (feature: string) => {
  if (feature === 'Assessoria e Consultoria')
    return [
      { name: 'Assessoria Cadastral', route: ExternalRoutes.juridico.assessoria_cadastral },
      { name: 'Jurídico Fácil', route: ExternalRoutes.juridico.juridico_facil },
      { name: 'Envie sua Dúvida', route: ExternalRoutes.juridico.duvidas },
      { name: 'Legislações', route: ExternalRoutes.juridico.legislacoes },
      { name: 'Artigos Jurídicos', route: ExternalRoutes.juridico.artigos },
    ];
  if (feature === 'Análise Estratégica')
    return [
      {
        name: 'Análise de Mercado 3.0',
        route: ExternalRoutes.analise_estrategica.pesquisa_de_precos,
      },
      {
        name: 'Meu histórico',
        route: ExternalRoutes.analise_estrategica.meu_historico,
      },
      { name: 'Análise de Mercado', route: ExternalRoutes.analise_estrategica.analise },
      { name: 'Concorrentes', route: ExternalRoutes.analise_estrategica.concorrentes },
      { name: 'Contratos', route: ExternalRoutes.analise_estrategica.contratos },
      {
        name: 'Ata de Registro de Preço',
        route: ExternalRoutes.analise_estrategica.ata_de_registro_preco,
      },
    ];
  if (feature === 'Treinamento e Capacitação')
    return [
      { name: 'Conlicitação Academy', route: ExternalRoutes.academy },
      { name: 'ConLicita Go', route: ExternalRoutes.cursos },
      { name: 'Cursos in Company', route: 'https://www.institutolicitar.com.br/in-company' },
    ];
  if (feature === 'Dashboard Robô de Lances')
    return [
      { name: 'Usuários Online', route: '/robo_dashboard/online' },
      { name: 'Usuários', route: '/robo_dashboard/usuarios' },
      { name: 'Licitações', route: '/robo_dashboard/licitacoes' },
    ];

  return [
    { name: 'Bolsa de Empregos', route: ExternalRoutes.mais.bolsa_empregos },
    { name: 'Clipping Polícia Federal', route: ExternalRoutes.mais.clipping_policia_federal },
    { name: 'API ConLicitação', route: ExternalRoutes.mais.api },
    { name: 'Status das Ferramentas', route: ExternalRoutes.mais.status },
  ];
};

const menuClass = (feature: string) => {
  const currentRoute = window.location.pathname;
  if (feature === 'Assessoria e Consultoria')
    if (
      currentRoute.includes(ExternalRoutes.juridico.assessoria_cadastral) ||
      currentRoute.includes(ExternalRoutes.juridico.juridico_facil) ||
      currentRoute.includes(ExternalRoutes.juridico.legislacoes) ||
      currentRoute.includes(ExternalRoutes.juridico.artigos) ||
      currentRoute.includes(ExternalRoutes.juridico.legislacoes) ||
      currentRoute.includes(ExternalRoutes.juridico.duvidas)
    )
      return 'nav-item nav-current';

  if (feature === 'Análise Estratégica')
    if (
      currentRoute.includes(ExternalRoutes.analise_estrategica.analise) ||
      currentRoute.includes(ExternalRoutes.analise_estrategica.contratos) ||
      currentRoute.includes(ExternalRoutes.analise_estrategica.concorrentes) ||
      currentRoute.includes(ExternalRoutes.analise_estrategica.meu_historico) ||
      currentRoute.includes(ExternalRoutes.analise_estrategica.ata_de_registro_preco) ||
      currentRoute.includes(ExternalRoutes.analise_estrategica.pesquisa_de_precos)
    )
      return 'nav-item nav-current';

  if (feature === 'Treinamento e Capacitação')
    if (
      currentRoute.includes(ExternalRoutes.cursos) ||
      currentRoute.includes(ExternalRoutes.academy)
    )
      return 'nav-item nav-current';

  if (feature === 'Mais')
    if (
      currentRoute.includes(ExternalRoutes.mais.api) ||
      currentRoute.includes(ExternalRoutes.mais.bolsa_empregos) ||
      currentRoute.includes(ExternalRoutes.mais.status) ||
      currentRoute.includes(ExternalRoutes.mais.clipping_policia_federal)
    )
      return 'nav-item nav-current';

  return 'nav-item';
};

const SideBarMultipleItem = (props: SideBarMultipleItemProps) => {
  const dispatch = useDispatch();
  const { feature, representant, classTour } = props;
  const { menus_behaviour } = useSelector<ApplicationState, MenusBehaviourState>(
    (state) => state.session.menus_behaviour,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  // Ferramentas em fase alfa: item de menu só para clientes alfa_testers.
  const alfaOnlyRoutes: string[] = [ExternalRoutes.academy];
  const items = featureItems(feature)?.filter((item) => {
    if (item.route === ExternalRoutes.analise_estrategica.pesquisa_de_precos)
      return canAccessPriceIntelligence(profile);
    return !alfaOnlyRoutes.includes(item.route) || profile?.alfa_tester;
  });

  const collapsableItem = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menus_behaviour.sideBar) collapsableItem.current?.classList.remove('show');
  }, [menus_behaviour.sideBar]);

  return (
    <li
      onClick={() => dispatch({ type: MenusBehaviourTypes.OPEN_SIDEBAR })}
      className={`${menuClass(feature)} ${classTour}`}
    >
      <a
        aria-label={feature}
        className={`link-accordion nav-link ${
          representant ? 'representant' : '  '
        } databalloon tour-legal-menu collapsed`}
        data-balloon-pos="right"
        data-target={`#${featureIdName(feature)}`}
        data-toggle="collapse"
        href="#"
        role="button"
        aria-expanded="true"
      >
        <span className="nav-icon">
          <img alt={feature} src={featureIcon(feature)} />
        </span>
        <span className="nav-name">{feature}</span>
        {/* <i className="material-icons ml-auto nav-arrow mr-2">v</i> */}
        <span className="oi oi-chevron-bottom ml-auto nav-arrow mr-2" />
      </a>
      <div
        ref={collapsableItem}
        aria-labelledby="dLabel"
        className="collapse"
        data-parent="#accordion-menu"
        id={featureIdName(feature)}
        role="menu"
      >
        <ul className="nav flex-column second-menu">
          {items?.map((item, index) => (
            <li key={index as number} className="nav-item">
              <a
                className={`nav-link ${
                  representant ? 'representant' : '  '
                } databalloon tour-easy-legal-menu`}
                href={item.route}
                onClick={() => createTrack(`Menu - Clicou na ferramenta ${item.name}`)}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default SideBarMultipleItem;
